<template>
    <v-btn text outlined block :style="buttonStyle" @click="credentialLogin" :loading="loading || authInProgress" :disabled="loading || authInProgress" class="credential-login-button" data-testing="credential-login-button">
        <v-layout row wrap align-center>
            <v-flex class="icon">
                <v-icon>{{ icon || 'pin' }}</v-icon>
            </v-flex>
            <v-flex row wrap>
                <div class="text-none px-3" style='font-family: "Google Sans",arial,sans-serif;'>{{ label || $t('LOGIN_CREDENTIAL_ANONYMOUS')}}</div>
            </v-flex>
        </v-layout>
    </v-btn>
</template>

<script lang="ts">
import Vue from "vue";
import { Component, Prop } from "vue-property-decorator";
import azureLogo from '../../../assets/azure.svg';
import Config from '@/config';
import { Base64 } from "js-base64";
import { useErrorStore } from "@/stores/errorStore";
import { useApiClientStore } from "@/stores/apiClientStore";
import { useAuthenticationStore } from "@/stores/authenticationStore";
import { storeToRefs } from "pinia";

@Component({})
export default class CredentialLoginButton extends Vue {
    // TODO: Change to composition api
    error = storeToRefs(useErrorStore()).errorMessage;
    // END TODO
    @Prop() credentialCode;
    @Prop() competitionId;
    @Prop() mode;
    @Prop() provider;
    @Prop() cognitoClientId;
    @Prop() cognitoBaseUrl;
    @Prop() label;
    @Prop() icon;
    get loading() { return useApiClientStore().isLoading; }
    login = (payload: { provider: string, token: string }) => useAuthenticationStore().login(payload);
    authInProgress = false;
    
    buttonStyle(): object {
        return {
            height: '48px',
            'background-color': 'white'
        }
    }

    async credentialLogin() 
    {
        let redirectUrl = new URL(`/${this.mode}`, Config.LOGIN_UI_BASE_URL);

        let data = Base64.encode(JSON.stringify({
            competitionId: this.competitionId,
            provider: this.provider,
            redirectUrl: this.$route.query.redirect_url
        }), true);

        window.location.href = new URL(`/login?response_type=code&redirect_uri=${redirectUrl.href}&client_id=${this.cognitoClientId}&state=${data}`, this.cognitoBaseUrl).href;
    }

    get state(): {competitionId:string, provider:string, redirectUrl:string}
    {
        return JSON.parse(Base64.decode(<string>this.$route.query?.state) || {});
    }

    async created() 
    {
        try
        {
            this.authInProgress = true;

            if (this.credentialCode && this.provider === this.state.provider)
            {
                const redirectUrl = new URL(window.location.pathname, window.location.origin).href;

                if (await this.login({ provider: this.provider, token: btoa(JSON.stringify({code: this.credentialCode, redirectUrl }))})) 
                {
                    this.$emit("confirm");
                    useErrorStore().resetError();
                } 
                else 
                {
                    if (!this.error)
                    {
                        useErrorStore().setError({ message: this.$t("LOGIN_UNABLE_TO_LOGIN_TEXT") });
                    }
                }
            }
        }
        catch(e)
        {
            useErrorStore().setError(e);
            TrackJS.track(e);
        }
        finally
        {
            this.authInProgress = false;
        }
    }
}
</script>

<style scoped>
.credential-login-button:focus {
    box-shadow: 0 0 0 0.15rem #1867c0 !important;
}
</style>
